import { createSelector } from 'reselect';

export const getPaymentDataState = state => state.payment;

export const getPaymentDataIsFetching = createSelector(
  getPaymentDataState,
  payment => payment.isFetching
);
